export const COMMENT_DRAWER_MODES = {
  EDIT: 'EDIT',
  CREATE: 'CREATE',
  VIEW: 'VIEW'
}
